// Taken from https://github.com/bgrins/TinyColor
export const ColorConfig = [
  {hex: '#f0f8ff', name: 'aliceblue'},
  {hex: '#faebd7', name: 'antiquewhite'},
  {hex: '#00ffff', name: 'aqua'},
  {hex: '#7fffd4', name: 'aquamarine'},
  {hex: '#f0ffff', name: 'azure'},
  {hex: '#f5f5dc', name: 'beige'},
  {hex: '#ffe4c4', name: 'bisque'},
  {hex: '#000000', name: 'black'},
  {hex: '#ffebcd', name: 'blanchedalmond'},
  {hex: '#0000ff', name: 'blue'},
  {hex: '#8a2be2', name: 'blueviolet'},
  {hex: '#a52a2a', name: 'brown'},
  {hex: '#deb887', name: 'burlywood'},
  {hex: '#ea7e5d', name: 'burntsienna'},
  {hex: '#5f9ea0', name: 'cadetblue'},
  {hex: '#7fff00', name: 'chartreuse'},
  {hex: '#d2691e', name: 'chocolate'},
  {hex: '#ff7f50', name: 'coral'},
  {hex: '#6495ed', name: 'cornflowerblue'},
  {hex: '#fff8dc', name: 'cornsilk'},
  {hex: '#dc143c', name: 'crimson'},
  {hex: '#00ffff', name: 'cyan'},
  {hex: '#00008b', name: 'darkblue'},
  {hex: '#008b8b', name: 'darkcyan'},
  {hex: '#b8860b', name: 'darkgoldenrod'},
  {hex: '#a9a9a9', name: 'darkgray'},
  {hex: '#006400', name: 'darkgreen'},
  {hex: '#a9a9a9', name: 'darkgrey'},
  {hex: '#bdb76b', name: 'darkkhaki'},
  {hex: '#8b008b', name: 'darkmagenta'},
  {hex: '#556b2f', name: 'darkolivegreen'},
  {hex: '#ff8c00', name: 'darkorange'},
  {hex: '#9932cc', name: 'darkorchid'},
  {hex: '#8b0000', name: 'darkred'},
  {hex: '#e9967a', name: 'darksalmon'},
  {hex: '#8fbc8f', name: 'darkseagreen'},
  {hex: '#483d8b', name: 'darkslateblue'},
  {hex: '#2f4f4f', name: 'darkslategray'},
  {hex: '#2f4f4f', name: 'darkslategrey'},
  {hex: '#00ced1', name: 'darkturquoise'},
  {hex: '#9400d3', name: 'darkviolet'},
  {hex: '#ff1493', name: 'deeppink'},
  {hex: '#00bfff', name: 'deepskyblue'},
  {hex: '#696969', name: 'dimgray'},
  {hex: '#696969', name: 'dimgrey'},
  {hex: '#1e90ff', name: 'dodgerblue'},
  {hex: '#b22222', name: 'firebrick'},
  {hex: '#fffaf0', name: 'floralwhite'},
  {hex: '#228b22', name: 'forestgreen'},
  {hex: '#ff00ff', name: 'fuchsia'},
  {hex: '#dcdcdc', name: 'gainsboro'},
  {hex: '#f8f8ff', name: 'ghostwhite'},
  {hex: '#ffd700', name: 'gold'},
  {hex: '#daa520', name: 'goldenrod'},
  {hex: '#808080', name: 'gray'},
  {hex: '#008000', name: 'green'},
  {hex: '#adff2f', name: 'greenyellow'},
  {hex: '#808080', name: 'grey'},
  {hex: '#f0fff0', name: 'honeydew'},
  {hex: '#ff69b4', name: 'hotpink'},
  {hex: '#cd5c5c', name: 'indianred'},
  {hex: '#4b0082', name: 'indigo'},
  {hex: '#fffff0', name: 'ivory'},
  {hex: '#f0e68c', name: 'khaki'},
  {hex: '#e6e6fa', name: 'lavender'},
  {hex: '#fff0f5', name: 'lavenderblush'},
  {hex: '#7cfc00', name: 'lawngreen'},
  {hex: '#fffacd', name: 'lemonchiffon'},
  {hex: '#add8e6', name: 'lightblue'},
  {hex: '#f08080', name: 'lightcoral'},
  {hex: '#e0ffff', name: 'lightcyan'},
  {hex: '#fafad2', name: 'lightgoldenrodyellow'},
  {hex: '#d3d3d3', name: 'lightgray'},
  {hex: '#90ee90', name: 'lightgreen'},
  {hex: '#d3d3d3', name: 'lightgrey'},
  {hex: '#ffb6c1', name: 'lightpink'},
  {hex: '#ffa07a', name: 'lightsalmon'},
  {hex: '#20b2aa', name: 'lightseagreen'},
  {hex: '#87cefa', name: 'lightskyblue'},
  {hex: '#778899', name: 'lightslategray'},
  {hex: '#778899', name: 'lightslategrey'},
  {hex: '#b0c4de', name: 'lightsteelblue'},
  {hex: '#ffffe0', name: 'lightyellow'},
  {hex: '#00ff00', name: 'lime'},
  {hex: '#32cd32', name: 'limegreen'},
  {hex: '#faf0e6', name: 'linen'},
  {hex: '#ff00ff', name: 'magenta'},
  {hex: '#800000', name: 'maroon'},
  {hex: '#66cdaa', name: 'mediumaquamarine'},
  {hex: '#0000cd', name: 'mediumblue'},
  {hex: '#ba55d3', name: 'mediumorchid'},
  {hex: '#9370db', name: 'mediumpurple'},
  {hex: '#3cb371', name: 'mediumseagreen'},
  {hex: '#7b68ee', name: 'mediumslateblue'},
  {hex: '#00fa9a', name: 'mediumspringgreen'},
  {hex: '#48d1cc', name: 'mediumturquoise'},
  {hex: '#c71585', name: 'mediumvioletred'},
  {hex: '#191970', name: 'midnightblue'},
  {hex: '#f5fffa', name: 'mintcream'},
  {hex: '#ffe4e1', name: 'mistyrose'},
  {hex: '#ffe4b5', name: 'moccasin'},
  {hex: '#ffdead', name: 'navajowhite'},
  {hex: '#000080', name: 'navy'},
  {hex: '#fdf5e6', name: 'oldlace'},
  {hex: '#808000', name: 'olive'},
  {hex: '#6b8e23', name: 'olivedrab'},
  {hex: '#ffa500', name: 'orange'},
  {hex: '#ff4500', name: 'orangered'},
  {hex: '#da70d6', name: 'orchid'},
  {hex: '#eee8aa', name: 'palegoldenrod'},
  {hex: '#98fb98', name: 'palegreen'},
  {hex: '#afeeee', name: 'paleturquoise'},
  {hex: '#db7093', name: 'palevioletred'},
  {hex: '#ffefd5', name: 'papayawhip'},
  {hex: '#ffdab9', name: 'peachpuff'},
  {hex: '#cd853f', name: 'peru'},
  {hex: '#ffc0cb', name: 'pink'},
  {hex: '#dda0dd', name: 'plum'},
  {hex: '#b0e0e6', name: 'powderblue'},
  {hex: '#800080', name: 'purple'},
  {hex: '#663399', name: 'rebeccapurple'},
  {hex: '#ff0000', name: 'red'},
  {hex: '#bc8f8f', name: 'rosybrown'},
  {hex: '#4169e1', name: 'royalblue'},
  {hex: '#8b4513', name: 'saddlebrown'},
  {hex: '#fa8072', name: 'salmon'},
  {hex: '#f4a460', name: 'sandybrown'},
  {hex: '#2e8b57', name: 'seagreen'},
  {hex: '#fff5ee', name: 'seashell'},
  {hex: '#a0522d', name: 'sienna'},
  {hex: '#c0c0c0', name: 'silver'},
  {hex: '#87ceeb', name: 'skyblue'},
  {hex: '#6a5acd', name: 'slateblue'},
  {hex: '#708090', name: 'slategray'},
  {hex: '#708090', name: 'slategrey'},
  {hex: '#fffafa', name: 'snow'},
  {hex: '#00ff7f', name: 'springgreen'},
  {hex: '#4682b4', name: 'steelblue'},
  {hex: '#d2b48c', name: 'tan'},
  {hex: '#008080', name: 'teal'},
  {hex: '#d8bfd8', name: 'thistle'},
  {hex: '#ff6347', name: 'tomato'},
  {hex: '#40e0d0', name: 'turquoise'},
  {hex: '#ee82ee', name: 'violet'},
  {hex: '#f5deb3', name: 'wheat'},
  {hex: '#ffffff', name: 'white'},
  {hex: '#f5f5f5', name: 'whitesmoke'},
  {hex: '#ffff00', name: 'yellow'},
  {hex: '#9acd32', name: 'yellowgreen'},
];
